import React from "react";
import { Global, Collection } from "@sourceflow-uk/sourceflow-sdk";
import { SourceFlowHead } from "@sourceflow-uk/sourceflow-head";
import metaObject from "@/.sourceflow/metadata.json";
import sourceflowEnums from "@/sourceflow.enums";
import ReadyCTABanner from "components/ReadyCTABanner";
import SubBanner from "@/components/SubBanner";
import JobSearch from "@/components/JobSearch";

// import JobSearch from "components/JobSearch";
// import MainBanner from "@/components/MainBanner";
// import SimpleFormWithColumn from "@/components/SimpleFormWithColumn";

import {
  Container,
} from 'reactstrap';

import { router } from "@/routes";
import { useLocale } from "@/hooks/useLocale";
/**
 *
 * @param global
 * @param meta
 * @returns {JSX.Element}
 * @constructor
 */
export default function Jobs({
  global,
  meta,
  sectorIds
}) {
  const locale = useLocale();

  return (
    <>
      <SourceFlowHead
        metaObject={metaObject}
        title={meta.title}
        description={meta.description}
        canonical={meta.canonical}
      />
      <div className="bg-light-white">
        <SubBanner
          global={global}
          pathPrefix={`all_jobs.page.sub_banner`}
          heading={`Job Search`}
          content={<p>Looking for a new teaching role? Tradewind helps educators just like you to find their ideal classroom job.</p>}
          breadcrumb_title={<><span className="active">Job Search</span></>}
          wave_color={`light-grey`}
          showJobSearchInput={true}
          className={`pt-4 jobs-page`}
          waveIcon={false}
        />
        <JobSearch
          global={global}
          pathPrefix={`all_jobs.page.job_search`}
          // content_1={`Enter job title or location`}
          all_jobs={true}
          showJobSearchInput={true}
          sectorIds={sectorIds}
        />
        <ReadyCTABanner
          global={global}
          pathPrefix={`all_jobs.page.ready_cta_banner`}
          data-color={`light-grey`}
        />
      </div>
    </>
  );
}

/**
 *
 * @returns {Promise<{props: {meta: {description: string, canonical: string, title: string}, jobs: *, global}}>}
 */
export async function getStaticProps() {
  const global = (await Global()).toJson();

  const sector = await Collection('job_titles')
  // const sectorIds = sector.map('id').getItems()
  const sectorIds = sector
    //Exclude from getting Recruitment Sector value
    // .filter(item => item.id !== '2400a212-abe4-4e55-a0dd-8763dc6140fa')
    .map(item => item.id).getItems();

  const routerKey = "jobs";

  return {
    props: {
      global,
      sectorIds,
      meta: {
        title: "Job Search | Tradewind Recruitment",
        description: `${sourceflowEnums.seo.genericDescription}`,
        // canonical: sourceflowEnums.seo.baseURL,
        canonical: `${sourceflowEnums.seo.baseURL}${router[routerKey]["en"]}`,
        // alternate: { link: router[routerKey]["en"], lang: "en" },
      },
    },
  };
}

// -- Reference -- //
// https://github.com/sourceflow-uk/components/pkgs/npm/sourceflow-head
// https://github.com/sourceflow-uk/components/pkgs/npm/sourceflowtext
// https://github.com/sourceflow-uk/components/pkgs/npm/job-search